<ng-template #perk let-iconame='iconame' let-title="title" let-desc="desc">
  <article class="card border-0">
    <div class="card-body px-4">
      <app-fa-icon [iconName]="iconame" classes="fa-2x mr-3 d-inline" [gradient]="true" width="2" height="2"></app-fa-icon>
      <h3 class="h5 font-weight-medium d-inline position-relative" style="top:4px;">
          {{title}}
      </h3>
      <p class="pt-4">
        {{desc}}
      </p>
    </div>
  </article>
</ng-template>

<div>
  <div class="row" style="margin-right: 0; margin-left: 0">
    <div class="col-12 col-md-6 bg-alt px-6 py-3 px-lg-8 py-lg-5">
      <p class="brand-header">CLIMB OUT IN <i style="font-weight:900;">FRONT</i> <sub>®</sub></p>
      <p class="brand-body">Award-Winning Mountain Care. Our travel policy includes standards around COVID-19 hygiene. It is our first priority to keep you safe, both on the mountain - and off.</p>
    </div>
    <div class="col-12 col-md-6 bg-secondary px-6 py-3 px-lg-8 py-lg-5">
      <p class="brand-header">CLIMB ON <i style="font-weight:900;">YOUR</i> TIME</p>
      <p class="brand-body">Your vacation with Kopa Tours includes a <i style="font-weight:600;">Flexible Booking Guarantee</i>. Cancel and rebook your tour up to 15 days before departure, at no charge. &nbsp;<small><u><a routerLink="/helpful-information/refund-policy">Learn more</a></u></small>.</p>
    </div>
  </div>
</div>

<div class="container space-top-1">
  <div class="row space-bottom-1">
    <div class="col-lg-6">
      <h1 class="respHead">Bookings + Rates</h1>
    </div>
    <div class="col-lg-6 text-center">
      <h3 class="respQues">Questions about our Trips?</h3>
      <app-kopa-button class=" " color="secondary" text="Send us a Message" link="../../helpful-information"></app-kopa-button>
    </div>
  </div>
  <tabset>
    <tab>
      <ng-template tabHeading>Kilimanjaro Tours</ng-template>
      <div class="space-top-1">
        <app-bookable-row-entry
           title="Machame Route: the Most Popular Trail on Mount Kilimanjaro"
           description="Enjoy a 6 day hike + 2 nights at a relaxing hotel. You will have a private tour up Kilimanjaro, with your mountain guide, waiter, chef, and climbing crew! All meals included."
           refUrl="https://kopatours.com/helpful-information/booking-and-rates"
           learnMoreUrl="/kilimanjaro/machame-route"
           calendarId="172676"
           shoutout="Bestseller"
           skillRating="Intermediate level"
           reviewRating="4.93"
           durationSnippet="6 day + 2 night hotel"
           imagePath="500x300/happy-kopa-hiker.jpg"
           price="$2,454" strikedPrice="$2,699">
        </app-bookable-row-entry>

       <app-bookable-row-entry
          title="Marangu Route: Climb Kilimanjaro in Comfort, sleep in Relaxing Mountain Huts"
          description="Vacation package includes a 5 day hike + 2 nights at a relaxing hotel. You will have a private tour up Kilimanjaro, with your mountain guide, waiter, chef, and climbing crew! All meals included."
          refUrl="https://kopatours.com/helpful-information/booking-and-rates"
          learnMoreUrl="/kilimanjaro/marangu-route"
          calendarId="192423"
          durationSnippet="5 day + 2 night hotel"
          skillRating="Intermediate level"
          reviewRating="4.87"
          imagePath="500x300/marangu-huts-in-forest.jpg"
          price="$2,199" strikedPrice="$2,479">
        </app-bookable-row-entry>

        <app-bookable-row-entry
           title="Lemosho Route: Slow and Steady hike up Kilimanjaro from the West - a Trail with Unparalleled Beauty"
           description="Join us for an 8 day hike + 2 nights at a relaxing hotel. You will have a private tour up Kilimanjaro, with your mountain guide, waiter, chef, and climbing crew! All meals included."
           refUrl="https://kopatours.com/helpful-information/booking-and-rates"
           learnMoreUrl="/kilimanjaro/lemosho-route"
           calendarId="192431"
           durationSnippet="8 day + 2 night hotel"
           skillRating="All levels"
           reviewRating="4.91"
           imagePath="500x300/lemosho-wide-shot-md.jpg"
           price="$2,999" strikedPrice="$3,329">
         </app-bookable-row-entry>
      </div>
    </tab>
    <tab>
      <ng-template tabHeading>Safari Tours</ng-template>
      <div class="space-top-1">
        <app-bookable-row-entry
           title="Culture Quest Safari: Wildlife Highlights + Get Personal with African Tribal Culture"
           description="This 4 day + 3 night safari takes you through national parks as well as culture centers. Meet members of the Maasai tribe, see wildlife, and rest comfortably in luxury hotels each night of the trip. All meals, hotels, and transport is included."
           refUrl="https://kopatours.com/helpful-information/booking-and-rates"
           learnMoreUrl="/safari/culture-quest-safari"
           tourIcon="shuttle-van"
           calendarId="193055"
           skillRating="All levels"
           reviewRating="4.55"
           durationSnippet="4 day + 3 night hotel"
           imagePath="500x300/culture-quest-preview.jpg"
           price="$2,079" strikedPrice="$2,309">
        </app-bookable-row-entry>

        <app-bookable-row-entry
           title="Big Buck Safari: Most Popular Serengeti Safari Tour"
           description="Enjoy a 5 day safari + 4 nights at luxury hotels. Experience hundreds of wildlife encounters, glamp in the Serengeti, and explore the archeological dig site of humanity's first footsteps. All meals, hotels, and transport is included."
           refUrl="https://kopatours.com/helpful-information/booking-and-rates"
           learnMoreUrl="/safari/big-buck-safari"
           tourIcon="shuttle-van"
           calendarId="192144"
           shoutout="Bestseller"
           skillRating="All levels"
           reviewRating="4.67"
           durationSnippet="5 day + 4 night hotel"
           imagePath="500x300/big-buck-phone-photo.jpg"
           price="$2,519" strikedPrice="$2,829">
        </app-bookable-row-entry>

        <app-bookable-row-entry
           title="Lion's Share Safari: Luxury Expedition with Up Close Encounters to Africa's 'BIG 5' Animals"
           description="A safari photographer's dream; get up close with Lions, Cheetahs, Elephants, and endangered Black Rhinos. You will spend 3 days in the Serengeti, Africa's #1 Safari location for 2020. All meals, hotels, and transport is included."
           refUrl="https://kopatours.com/helpful-information/booking-and-rates"
           learnMoreUrl="/safari/lions-share-safari"
           calendarId="192954"
           durationSnippet="7 day + 6 night hotel"
           skillRating="All levels"
           reviewRating="4.90"
           imagePath="500x300/lions-share-preview.jpg"
           price="$3,289" strikedPrice="$3,669">
         </app-bookable-row-entry>
      </div>
    </tab>
    <tab>
      <ng-template tabHeading>Special Offers<app-fa-icon iconName="trophy" classes="ml-2" color="fg-alt-color"></app-fa-icon></ng-template>
      <div class="space-top-1">
        <!-- Card -->
        <a class="d-block border-bottom pb-5 mb-5"
          href="tel:866-816-5672">
          <div class="row mx-md-n2">
            <div class="col-md-4 px-md-2 mb-3 mb-md-0">
              <div class="position-relative">
                <img class="img-fluid w-100 rounded-lg" appLazyload="500x300/coupon.jpg" alt="Kopa Tours - Save $250 on a safari + kilimanjaro bundle">
              </div>
            </div>

            <div class="col-md-8">
              <div class="media mb-2">
                <div>
                  <div class="d-flex mt-1 ml-7 float-right">
                    <div class="text-right">
                      <span class="d-block h4 text-fg text-lh-sm mb-0">$250 OFF</span>
                    </div>
                  </div>
                  <div class="media-body">
                    <h3 class="text-hover-primary ">Climb Mount Kilimanjaro and Treat Yourself With a Safari Excursion</h3>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap flex-xl-nowrap justify-content-start align-items-center small text-muted mb-2">
                <div class="d-flex align-items-center">
                  <div class="avatar-group">
                    <span data-toggle="tooltip" data-placement="top" title="Reschedule your trip, fee free! We are here for you.">
                      <img appLazyload="icons/top-choice.svg" width="14" alt="Flexible Booking Guarantee">
                      <span class="ml-2">Flexible Booking Guarantee</span>
                    </span>
                  </div>
                </div>
                <div class="ml-lg-auto mt-2 mt-lg-0 d-flex flex-nowrap">
                  <div>
                    <app-fa-icon iconName="fire" classes="mr-1" color="fg-alt-color" width="1" height="2"></app-fa-icon>
                    Private tour(s)
                  </div>
                  <span class="text-muted mx-2">|</span>
                  <div class="d-inline-block">
                    <app-fa-icon iconName="clock" classes="mr-1" color="fg-alt-color" width="1" height="2"></app-fa-icon>
                    9+ days
                  </div>
                  <span class="text-muted mx-2">|</span>
                  <div class="d-inline-block">
                    <app-fa-icon iconName="signal" classes="mr-1"  color="fg-alt-color" width="1" height="2"></app-fa-icon>
                    All levels
                  </div>
                </div>
              </div>

              <p class="font-size-1 text-fg mb-0">Fly halfway across the world & push your limits to reach the summit ... then top off your vacation with a safari tour in the best safari parks of Africa. Enjoy luxury accomodations, all-inclusive meals, and the best-in-class safari drivers & guides.<br><br>* <small>$250 savings applies only with Safari tours which are 3+ days in duration.</small></p>
              <div class="d-flex flex-wrap mt-2">
                <a role="button"
                   class="btn btn-pill py-n2 text-fg btn-primary px-6 ml-auto">CALL TO LEARN MORE
                  <app-fa-icon iconName="phone" classes="ml-2"></app-fa-icon>
                </a>
                <span style="flex-basis:100%; width: 0"></span>
                <small class="text-muted ml-auto mr-9 mt-1">DEPARTURES EVERY DAY</small>
              </div>
            </div>
          </div>
        </a>
        <!-- End Card -->
      </div>
    </tab>
  </tabset>

  <div class="row space-bottom-1">
    <div class="col-12 col-lg-3">
      <h2 class="font-weight-bold">Why travel with Kopa Tours?</h2>
      <p>Climbing Kilimanjaro is more than just a vacation - it's a commitment to be the best version of yourself. Read on to see why we are the best tour operator on the mountain.<br><br>Join us today, lead the way - and Climb Out in Front<sup>®</sup>.</p>
      <app-kopa-button color="secondary" text="LEARN MORE" classes="mt-1 mt-lg-4 mb-4 px-4" link=""></app-kopa-button>
    </div>
    <div class="col-12 col-lg-9 d-flex flex-wrap justify-content-center">
      <ng-container *ngTemplateOutlet="perk, context: {'iconame': 'hiking', 'title': 'Private Tours', 'desc': 'Every climb up the mountain is private - your own dedicated crew, staff, supplies, and meals.'}"></ng-container>
      <ng-container *ngTemplateOutlet="perk, context: {'iconame': 'seedling', 'title': 'Local Talent', 'desc': 'Our crew members were born on the mountain, and are local to the Kilimanjaro region. Climb with us to support the local economy.'}"></ng-container>
      <ng-container *ngTemplateOutlet="perk, context: {'iconame': 'user-shield', 'title': 'Safety Certified', 'desc': 'Fully licensed and professionally trained - helicopter-evac, emergency oxygen, you name it; we handle all situations.'}"></ng-container>
      <ng-container *ngTemplateOutlet="perk, context: {'iconame': 'handshake', 'title': 'Join the Crew', 'desc': 'When you climb with us, you become part of our Kopa Crew - a member of our exclusive community founded on humility, grit and trust.'}"></ng-container>
      <ng-container *ngTemplateOutlet="perk, context: {'iconame': 'mountain', 'title': 'Best in Class', 'desc': 'When you climb with us, you climb out in front. Members of the Kopa Crew have a 98% summit success rate.'}"></ng-container>
      <ng-container *ngTemplateOutlet="perk, context: {'iconame': 'bolt', 'title': '24/7 Hotline', 'desc': 'From booking, to packing, to travel and back - we have got you covered. Your dedicated Kopa Crew member is always a call or text away.'}"></ng-container>
    </div>
  </div>

</div>
